module.exports = __webpack_public_path__ + "static/media/what-matters-most-four.8e6e9739.png";